import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => (
  <footer className="bg-primary text-primary-foreground">
    <div className="container section-padding">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <h3 className="font-heading font-bold text-lg mb-3">Debnath Telecom</h3>
          <p className="text-sm opacity-80">Your trusted mobile & electronics store. We sell 100% genuine products with warranty and best prices.</p>
        </div>
        <div>
          <h4 className="font-heading font-semibold mb-3">Quick Links</h4>
          <div className="space-y-2 text-sm opacity-80">
            <Link to="/products" className="block hover:opacity-100">Products</Link>
            <Link to="/deals" className="block hover:opacity-100">Deals</Link>
            <Link to="/about" className="block hover:opacity-100">About Us</Link>
            <Link to="/contact" className="block hover:opacity-100">Contact</Link>
          </div>
        </div>
        <div>
          <h4 className="font-heading font-semibold mb-3">Categories</h4>
          <div className="space-y-2 text-sm opacity-80">
            <Link to="/products?category=smartphones" className="block hover:opacity-100">Smartphones</Link>
            <Link to="/products?category=led-tvs" className="block hover:opacity-100">LED TVs</Link>
            <Link to="/products?category=accessories" className="block hover:opacity-100">Accessories</Link>
            <Link to="/products?category=appliances" className="block hover:opacity-100">Appliances</Link>
          </div>
        </div>
        <div>
          <h4 className="font-heading font-semibold mb-3">Contact</h4>
          <div className="space-y-2 text-sm opacity-80">
            <p className="flex items-center gap-2"><Phone className="h-4 w-4" /> +91 96792 00493</p>
            <p className="flex items-center gap-2"><Mail className="h-4 w-4" /> chinmaydebnath21@gmail.com</p>
            <p className="flex items-center gap-2"><MapPin className="h-4 w-4" /> Kharagpur City Road, Baga Bhera, West Bengal, Pin 721437, India</p>
          </div>
        </div>
      </div>
      <div className="border-t border-primary-foreground/20 mt-8 pt-6 text-center text-sm opacity-60">
        <p>© {new Date().getFullYear()} Debnath Telecom & Variety Store. All rights reserved.</p>
        <div className="flex justify-center gap-4 mt-2">
          <Link to="/privacy-policy" className="hover:opacity-100 hover:underline">Privacy Policy</Link>
          <Link to="/disclaimer" className="hover:opacity-100 hover:underline">Disclaimer</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
